// constants

const SET_PERSONAL_DETAILS = "SET_PERSONAL_DETAILS";
const EMPTY_PERSONAL_DETAILS = "EMPTY_PERSONAL_DETAILS";

// reducers

const initialState = { name: "", email: "" };

const Reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PERSONAL_DETAILS:
      if (action.payload === {}) return { ...state };
      return { ...action.payload };
    case EMPTY_PERSONAL_DETAILS:
      return {};
    default:
      return state;
  }
};
export default Reducer;

// actions

export const setPersonalDetails = (obj = {}) => {
  return {
    type: SET_PERSONAL_DETAILS,
    payload: obj,
  };
};

export const emptyPersonalDetails = () => async (dispatch) => {
  dispatch({
    type: EMPTY_PERSONAL_DETAILS,
    // payload: arr,
  });
};
